import { useMutation } from '@tanstack/react-query';

import {
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';
import {
  IChannelDetailsDto,
  updateVkChannel,
  VkAuthorizeRequest,
} from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

interface IAuthorisationVkData {
  channelId: string;
  data: VkAuthorizeRequest;
}

export function useAuthorisationVk() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelsById = useInvalidateChannelById();
  const { addNotification } = useNotifications();

  const createMutation = useMutation({
    mutationFn: ({ channelId, data }: IAuthorisationVkData) =>
      updateVkChannel(channelId, data),
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const authorizeVk = (
    channelId: string,
    data: VkAuthorizeRequest,
    onCreated?: (data: IChannelDetailsDto) => void
  ) => {
    return createMutation.mutateAsync(
      { channelId, data },
      {
        onSuccess: async (channel) => {
          onCreated?.(channel);
          await Promise.all([
            invalidateChannelsList(),
            invalidateChannelsById(channel.id),
          ]);
        },
      }
    );
  };

  return { authorizeVk, ...createMutation };
}
